import { FC, useState } from 'react';
import { useFormik } from 'formik';
import { Flex } from 'antd';
import { ErrorMessage, ModalDialog, SInput } from '../..';
import { IProps, IInitialValues } from './type';
import styles from './index.module.scss';
import { INITIAL_VALUES } from './const';
import validationSchema from './validations';
import useHttpService from '../../../services/hook';
import { RequestMethods } from '../../../services/enum';
import EyeSolidB from '../../../assets/icons/eye-solid-b.svg';
import UserSlashSolidB from '../../../assets/icons/eye-slash-solid-b.svg';

const ResetPasswordModal: FC<IProps> = (props) => {
  const [isEyeOpenForOldPassword, setIsEyeOpenForOldPassword] =
    useState<boolean>(false);
  const [isEyeOpenForNewPassword, setIsEyeOpenForNewPassword] =
    useState<boolean>(false);
  const [isEyeOpenForNewPasswordAgain, setIsEyeOpenForNewPasswordAgain] =
    useState<boolean>(false);

  const handleClickEyeForOldPassword = () => {
    setIsEyeOpenForOldPassword((prev) => !prev);
  };

  const handleClickEyeForNewPassword = () => {
    setIsEyeOpenForNewPassword((prev) => !prev);
  };

  const handleClickEyeForNewPasswordAgain = () => {
    setIsEyeOpenForNewPasswordAgain((prev) => !prev);
  };

  const executeService = useHttpService();

  const onSubmit = async (values: IInitialValues) => {
    await executeService<unknown>({
      method: RequestMethods.POST,
      url: 'auth/user/change-password/',
      data: values,
    });
    props.handleSubmit();
  };

  const formik = useFormik<IInitialValues>({
    initialValues: INITIAL_VALUES,
    validationSchema,
    onSubmit,
  });

  return (
    <ModalDialog
      title={props.title}
      subTitle={props.subTitle}
      open={props.open}
      handleOk={formik.handleSubmit}
      handleCancel={props.handleCancel}
    >
      <Flex gap="middle" vertical className={styles.container}>
        <Flex vertical gap="small">
          <SInput
            type={isEyeOpenForOldPassword ? 'text' : 'password'}
            placeholder="Eski Şifre"
            prefix={
              <img
                src={isEyeOpenForOldPassword ? UserSlashSolidB : EyeSolidB}
                alt="EyeSolidB"
                onClick={handleClickEyeForOldPassword}
              />
            }
            {...formik.getFieldProps('old_password')}
          />
          {formik.touched.old_password && formik.errors.old_password && (
            <ErrorMessage>{formik.errors.old_password}</ErrorMessage>
          )}
        </Flex>
        <Flex vertical gap="small">
          <SInput
            type={isEyeOpenForNewPassword ? 'text' : 'password'}
            placeholder="Yeni Şifre"
            prefix={
              <img
                src={isEyeOpenForNewPassword ? UserSlashSolidB : EyeSolidB}
                alt="EyeSolidB"
                onClick={handleClickEyeForNewPassword}
              />
            }
            {...formik.getFieldProps('password')}
          />
          {formik.touched.password && formik.errors.password && (
            <ErrorMessage>{formik.errors.password}</ErrorMessage>
          )}
        </Flex>
        <Flex vertical gap="small">
          <SInput
            type={isEyeOpenForNewPasswordAgain ? 'text' : 'password'}
            placeholder="Yeni Şifre Tekrar"
            prefix={
              <img
                src={isEyeOpenForNewPasswordAgain ? UserSlashSolidB : EyeSolidB}
                alt="EyeSolidB"
                onClick={handleClickEyeForNewPasswordAgain}
              />
            }
            {...formik.getFieldProps('password_again')}
          />
          {formik.touched.password_again && formik.errors.password_again && (
            <ErrorMessage>{formik.errors.password_again}</ErrorMessage>
          )}
        </Flex>
      </Flex>
    </ModalDialog>
  );
};

export default ResetPasswordModal;
